import React from "react"
import RPMFollowUpView from "../components/RPMAdmin/component/RPMFollowUp/RPMFollowUpView"

const RPMFollowUp = () => <RPMFollowUpView />

export default RPMFollowUp
